import { UserNotification } from '../models/user-notification-state.model';

export class SetUserNotification {
  static readonly type = '[USER NOTIFICATION] Set user NOTIFICATION';

  constructor(public payload: UserNotification) {
  }
}
